<template>
  <div
    class="d-flex align-center justify-space-between px-4"
    :style="route.name !== 'homePage' ? `margin-bottom: 0px` : `margin-bottom: 87px`"
  >
    <v-btn
      variant="text"
      prepend-icon="mdi-chevron-left"
      @click="router.push('/')"
      v-if="route.name !== 'homePage'"
      :disabled="share_status"
    >
      <template v-slot:prepend>
        <v-icon></v-icon>
      </template>
      回首頁
    </v-btn>

    <div class="d-none d-lg-block" style="width: 785px" v-if="route.name !== 'homePage'">
      <v-row>
        <v-col cols="4">
          <v-radio-group
            v-model="searchMode"
            hide-details
            inline
            :disabled="share_status"
          >
            <v-radio color="primary" label="關鍵字" value="queryByKeyword"></v-radio>
            <v-radio
              color="primary"
              label="xObject ID"
              value="getxObjectsWithOutData"
            ></v-radio>
          </v-radio-group>
        </v-col>

        <v-col cols="8">
          <v-text-field
            rounded
            hide-details
            append-inner-icon="mdi-magnify"
            placeholder="請輸入廠牌/型號/類型/或其他關鍵字..."
            density="compact"
            variant="outlined"
            v-model="searchData"
            :disabled="share_status"
            @keypress.enter.prevent="searchValue()"
          ></v-text-field>
        </v-col>
      </v-row>
    </div>

    <div v-if="tokenValid" :class="{ 'ml-auto': route.name === 'homePage' }">
      <v-btn variant="text" :disabled="share_status" @click="routerPush('/my_component')"
        >我的元件</v-btn
      >

      <v-btn
        icon="mdi-heart-outline"
        variant="text"
        :disabled="share_status"
        @click="router.push('/commonly_used_components')"
      ></v-btn>

      <v-btn
        v-if="isRevit && tokenValid"
        icon="mdi-cart"
        variant="text"
        :disabled="share_status"
        @click="router.push('/export_list')"
      ></v-btn>
    </div>

    <div :class="{ 'ml-auto': route.name === 'homePage' }" v-else>
      <v-btn variant="text" @click="goLogin()">登入/註冊</v-btn>
    </div>
  </div>

  <div class="d-flex d-lg-none flex-column px-4" v-if="route.name !== 'homePage'">
    <v-text-field
      rounded
      hide-details
      append-inner-icon="mdi-magnify"
      placeholder="請輸入廠牌/型號/類型/或其他關鍵字..."
      density="compact"
      variant="outlined"
      v-model="searchData"
      :disabled="share_status"
      @keypress.enter.prevent="searchValue()"
    ></v-text-field>

    <div class="d-flex align-center">
      <v-btn
        icon="mdi-menu"
        variant="text"
        @click="filterMenuSwitch = !filterMenuSwitch"
      ></v-btn>

      <v-radio-group v-model="searchMode" :disabled="share_status" hide-details inline>
        <v-radio color="primary" label="關鍵字" value="queryByKeyword"></v-radio>
        <v-radio
          color="primary"
          label="xObject ID"
          value="getxObjectsWithOutData"
        ></v-radio>
      </v-radio-group>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from "vue";
import { useRouter, useRoute } from "vue-router";

import xObjectStore from "code-library/store/xObject.js";
import { storeToRefs } from "pinia";
import axiosAPIStore from "code-library/store/axiosAPI.js";
import searchComponentStore from "@/store/searchComponent.js";
import navbarButtonStore from "@/store/navbarButton.js";
import routerListStore from "@/store/routerList.js";

// -----------------------------------------------------------

import sharedComponentsStore from "@/store/sharedComponents.js";

const xObject = xObjectStore();
const router = useRouter();
const route = useRoute();
const axiosAPI = axiosAPIStore();
const searchComponent = searchComponentStore();
const navbarButton = navbarButtonStore();
const routerList = routerListStore();
const sharedComponents = sharedComponentsStore();

//state
const { filterData, searchKeyWords } = storeToRefs(xObject);
const { tokenValid } = storeToRefs(axiosAPI);
const { showCardData, loading, searchData, searchMode, showNoDataText } = storeToRefs(
  searchComponent
);
const { filterMenuSwitch } = storeToRefs(navbarButton);
const { share_status } = storeToRefs(sharedComponents);

//action
const { checkToken, getCookieByName, setCookieByName } = axiosAPI;
const { saveSearchKeyWords, queryByKeyword, getxObjectsWithOutData } = xObject;
const { markCommonComponents } = searchComponent;
const { routerPush } = routerList;

// --------------------------------------------------------------------
const localStorageSearchData = localStorage.getItem("searchKeyWords");

// const searchData = searchKeyWords;

const isRevit = ref(false);

onMounted(async () => {
  tokenValid.value = await checkToken();
  // searchData.value = localStorageSearchData;
  //判斷是否從Revit登入
  // const getRevitJudge = localStorage.getItem("wvUserLoginMode") || null;
  const getRevitJudge = getCookieByName("wvUserLoginMode") || null;

  isRevit.value = getRevitJudge === "1";
});

// 搜尋
async function searchValue() {
  switch (searchMode.value) {
    case "queryByKeyword":
      await router.push({
        path: "/search_component",
        query: {
          keyword: searchData.value,
        },
      });
      break;
    case "getxObjectsWithOutData":
      // 搜尋框用 xobjectId 去尋時，route.name 是 "searchComponent" 或 "myComponent"，就留在原網站
      // route.name 不是時，前往 /search_component

      // const path =
      //   route.name === "searchComponent" || route.name === "myComponent"
      //     ? route.path
      //     : "/search_component";

      // await router.push({
      //   path,
      //   query: {
      //     xObjectId: searchData.value,
      //   },
      // });

      // if (route.name === "myComponent") {
      //   window.location.reload();
      // }

      await router.push({
        path: "/search_component",
        query: {
          xObjectId: searchData.value,
        },
      });
      break;
  }

  if (route.name === "searchComponent") {
    window.location.reload();
  }
}

// 前往 登入/註冊
function goLogin() {
  localStorage.setItem("path", window.location.href);
  // document.cookie = 'path=' + window.location.href + ';domain=.mindlogic.com.tw;max-age=2592000;path=/;';
  setCookieByName("path", window.location.href);

  window.location.href = `${process.env.VUE_APP_LOGIN}`;
}
</script>
